"use client";

import { createSVGIcon } from "@faire/slate/lib/iconUtils";
import React from "react";

/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=13%3A455))
 * @trackcomponent
 * @lastsynced 2025-04-11T14:43:34.914Z
 * @optimized using svgo:^3.0.2
 */
export const Luxembourg = createSVGIcon(
  <>
    <path fill="#fff" d="M1 1H17V13H1z" />
    <path fill="#B64343" d="M1 1H17V5H1z" />
    <path fill="#58889B" d="M1 9H17V13H1z" />
    <path stroke="#757575" d="M1 1H17V13H1z" />
  </>,
  "Luxembourg",
  (strictLocalize) => ({
    viewBox: "0 0 18 14",
    fill: "none",
    titleAccess: strictLocalize({
      id: "wYaPId",
      defaultMessage: "Luxembourg flag",
      description: { text: "The label for the Luxembourg flag icon" },
    }),
  })
);
